<template>    
    <hooper 
        :itemsToShow="isDesktopVersion() && banners.length > 1 ? 2 : 1" 
        :class="{'rounded-[15px]' : $root.template === 'video_template' || $root.template === 'slider_template'}" 
            v-if="banners.length > 0 || ['thekamsky', 'residencehotel', 'farmvillage', 'operasuite', 'palmira-palace', 'megumi', 'bigwood'].includes($root.hotelCode)" 
        :autoPlay="autoplay" 
        :rtl="doRtl()" 
        :playSpeed="$root.hotelCode === 'yaltaintourist' ? '7000' : ($root.hotelCode === 'novoteldusseldorfairport' ? '5000' : '3000')" 
        :infiniteScroll="true"
        :style="!isDesktopVersion() ? { boxShadow: '1px 0px 12px rgba(0, 0, 0, 0.12)' } : { boxShadow: 'none' }"
        >
        <slide v-if="$root.hotelCode == 'thekamsky'">
            <!--<iframe src="//playercdn.cdnvideo.ru/aloha/players/auto_player1.html?clid=yekbykp2oz&plid=3bbd0375-ad3e-4ca8-937b-f88e2ca2d025" allow="fullscreen *; autoplay" style="overflow: hidden;width: 100%;height: 100%; position:fixed;border: none;border-radius:3px;"></iframe>-->            
            <video autoplay muted loop playsinline id="myVideo" style="width: 100%; max-height: 100%; border-radius: 3px;">
              <source src="https://admin.2roomz.com/videos/thekamsky_rest.mp4" type="video/mp4">
            </video>
        </slide>
        <slide v-if="$root.hotelCode == 'farmvillage'">
            <video autoplay muted loop playsinline id="myVideo" style="width: 100%; max-height: 100%; border-radius: 3px;">
              <source src="https://admin.2roomz.com/videos/farmvillage.mp4" type="video/mp4">
            </video>
        </slide>
        <slide v-if="$root.hotelCode == 'operasuite'">
            <video autoplay muted loop playsinline id="myVideo" style="width: 100%; max-height: 100%; border-radius: 3px;">
              <source src="https://admin.2roomz.com/videos/operasuite.mp4" type="video/mp4">
            </video>
        </slide>
        <slide v-if="$root.hotelCode == 'megumi'">
            <video autoplay muted loop playsinline id="myVideo" style="width: 100%; max-height: 100%; border-radius: 3px;">
              <source src="https://admin.2roomz.com/videos/megumi.mp4" type="video/mp4">
            </video>
        </slide>
        <slide v-if="$root.hotelCode == 'bigwood'">
            <video autoplay muted loop playsinline id="myVideo" style="width: 100%; max-height: 100%; border-radius: 3px;">
              <source src="https://admin.2roomz.com/videos/bigwood.mp4" type="video/mp4">
            </video>
        </slide>
        <slide v-if="$root.hotelCode == 'residencehotel'">
            <video autoplay muted loop playsinline id="myVideo" style="width: 100%; max-height: 100%; border-radius: 3px;">
              <source src="https://admin.2roomz.com/videos/residencehotel.mp4" type="video/mp4">
            </video>
        </slide>
        <!--
        <slide v-if="$root.hotelCode == 'bogatyr-castle'">
            <video autoplay muted loop playsinline id="myVideo" style="width: 100%; max-height: 100%; border-radius: 3px;">
              <source src="https://admin.2roomz.com/videos/bogatyrcastle.mp4" type="video/mp4">
            </video>
        </slide>-->
        <slide v-if="$root.hotelCode == 'palmira-palace'">
            <video autoplay muted loop playsinline id="myVideo" style="width: 100%; max-height: 100%; border-radius: 3px;">
              <source src="https://admin.2roomz.com/videos/palmira.mp4" type="video/mp4">
            </video>
        </slide>
        <!--<slide v-if="$root.hotelCode == 'radissoncollection'">            
            <video autoplay muted loop playsinline id="myVideo" style="width: 100%; max-height: 100%; border-radius: 3px;">
              <source src="https://admin.2roomz.com/videos/radissoncollection_001.mp4" type="video/mp4">
            </video>
        </slide>-->
        <slide v-for="banner in banners" :key="banner.id">
            <img 
                :class="{
                    'rounded-[15px] shadow-lg transition-all duration-300 hover:scale-105': $root.template === 'video_template' || $root.template === 'slider_template',
                    'rounded shadow-md transition-all duration-300 hover:scale-105': $root.template !== 'video_template' && $root.template !== 'slider_template',
                    'w-full': !isDesktopVersion(),
                    'px-2 shadow-none': isDesktopVersion(),
                }"
                :src="$root.getImage(getLangImage(banner))" 
                @click="relocate(banner.external_link, banner.extra)"/>
        </slide>

        <hooper-pagination slot="hooper-addons" v-if="banners.length > 1"></hooper-pagination>
    </hooper>
</template>

<script>
    import { Hooper, Slide, Pagination as HooperPagination } from 'hooper'
    import 'hooper/dist/hooper.css';
    export default {
        name: "AppBanner",
        components: {Hooper, Slide, HooperPagination},

        computed: {
            autoplay: function () {
                return this.banners.length > 1;
            },
            banners() {
                if (this.$root.hotel.banners !== undefined && this.$root.hotel.banners.length > 0) {
                    return this.$root.hotel.banners.filter(item => item.position === 'bottom');
                }
                return [];
            }
        },

        methods: {
            /*
             * get banner, posted for current language
             */
            getLangImage(banner) {
                return (banner.file_langs !== null && banner.file_langs[this.$root.currentLanguage] && banner.file_langs[this.$root.currentLanguage].file) ? banner.file_langs[this.$root.currentLanguage].file : banner.banner;
            },
            /*
            relocate(link) {
                this.$root.yandexGoal('goal-click-banner');
                this.$root.yandexGoal('goal-click-banner-bottom');
                
                if (link !== null && link.length > 0) {
                    if (this.$root.hotel.relocatesite === 'hadassah.2roomz.com' || this.$root.hotel.site == 'hadassah-hospital.2roomz.com') {
                        window.open(link, '_blank').focus();
                    } else {
                        window.location.href = link;
                    }
                }
            }
            */
            relocate(link, extra) {
                this.$root.yandexGoal('goal-click-banner');
                this.$root.yandexGoal('goal-click-banner-bottom');
                if (extra && extra.goal_id) {
                    this.$root.yandexGoal(extra.goal_id);
                }
                
                if (link !== null && link.length > 0) {
                     window.open(link, '_blank').focus();
                }
            },
            doRtl() {
                if (this.$root.currentLanguage == 'il' || this.$root.currentLanguage == 'ar') {
                    return true;
                }
            },             
        }
    }
</script>

<style scoped>

</style>